import moment from 'moment';

class AlertNotification {
  constructor({
    id,
    userId,
    type,
    title,
    titleFr,
    body,
    bodyFr,
    link,
    created,
    read,
    flag,
    deleted,
    country,
  }) {
    this.id = id;
    this.userId = userId;
    this.type = type;
    this.title = title;
    this.titleFr = titleFr,
    this.body = body;
    this.bodyFr = bodyFr,
    this.link = link;
    this.created = moment(created);
    this.read = read && moment(read);
    this.flag = flag;
    this.deleted = deleted;
    this.country = country;
  }

  clone() {
    return new AlertNotification(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      UserId: this.userId,
      Type: this.type,
      UserType: this.userType,
      NotificationTitle: this.title,
      NotificationTitleFr: this.titleFr,
      Body: this.body,
      BodyFr: this.bodyFr,
      URLLink: this.link,
      Sent: this.created && this.read.format(),
      Read: this.read && this.read.format(),
      Flag: this.flag,
      Deleted: this.deleted,
      Country: this.country,
    };
  }

  static fromApiFormat(api) {
    return new AlertNotification({
      id: api.ID,
      userId: api.UserId,
      type: api.Type,
      title: api.NotificationTitle,
      titleFr: api.NotificationTitleFr,
      body: api.Body,
      bodyFr: api.BodyFr,
      link: api.URLLink,
      created: api.Sent,
      read: api.Read,
      flag: api.Flag,
      country: api.Country,
    });
  }
}

export default AlertNotification;
